exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dragarea{\r\n    font-size: 11px;\r\n    border: 3px solid #bbb; padding: 5px ;\r\n    background-color: #fff;\r\n    color: #bbb;\r\n}\r\n.droparea{\r\n    font-size: 11px;\r\n    border: 3px dashed #bbb; padding: 5px ;\r\n    background-color: #eff;\r\n    color: #aaa;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Projects/Empower360Plus/EmpowerWeb2.0/A4.Empower/A4.Empower/ClientApp/src/app/shared/file-upload/file-upload.component.css
// module id = ../../../../../src/app/shared/file-upload/file-upload.component.css
// module chunks = main